import { object, InferType, bool, number } from 'yup'

const schema = object({
  amount: number()
    .required('Amount is required')
    .min(300, 'Minimum amount is $3'),
  monthly: bool().required(),
}).defined()

export type Values = Required<InferType<typeof schema>>

export const useForm = () => {
  const initialValues: Values = {
    amount: 0,
    monthly: false,
  }

  return { initialValues, schema } as const
}